import React, { useState, useEffect } from 'react';

import { Typography } from '@mui/material';

import './ScanPackages.scss';
import { useGetMeMutation } from '../../../../common/apis/CommonApi';
import { useAppSelector } from '../../../../common/hooks/reduxHooks';
import { AVAILABLE_SCAN_PACKAGES } from '../../../constants/Purchases';
import { ScanPackage } from '../../../types/ScanPackageType';
import ScanPackageConfirmationModal from '../Modals/ScanPackageConfirmationModal';
import ScanPackagePurchasedModal from '../Modals/ScanPackagePurchasedModal';
import SubscriptionRequiredModal from '../Modals/SubscriptionRequiredModal';
import ScanPackageCell from '../ScanPackageCell/ScanPackageCell';

const ScanPackages: React.FC = () => {
  const { user } = useAppSelector((state) => state.model);
  const [getMeMutation] = useGetMeMutation();
  const [loading, setLoading] = useState(false);
  const [scanPackagePurchased, setScanPackagePurchased] = useState(false);
  const [confirmScanPackage, setConfirmScanPackage] = useState(false);
  const [scanPackageBeingPurchased, setScanPackageBeingPurchased] = useState<
    string | null
  >(null);
  const [subscriptionRequiredModal, setSubscriptionRequiredModal] =
    useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const session = urlParams.get('session');
    if (session) {
      window.history.replaceState(null, '', window.location.pathname);
      setScanPackagePurchased(true);
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 2500);
    }
  }, []);

  const purchaseScanPackage = async (scanPackage: ScanPackage) => {
    if (!user) return;

    if (!user.activeSubscriptionType) {
      setSubscriptionRequiredModal(true);
      return;
    }

    setScanPackageBeingPurchased(scanPackage.product_id);
    setConfirmScanPackage(true);
  };

  const cancelPurchase = () => {
    setScanPackageBeingPurchased(null);
    setConfirmScanPackage(false);
  };

  const confirmPurchase = () => {
    let stripeUrl;

    if (scanPackageBeingPurchased === 'scan_package_1') {
      stripeUrl = process.env.REACT_APP_STRIPE_SCAN_PACKAGE_1;
    } else if (scanPackageBeingPurchased === 'scan_package_10') {
      stripeUrl = process.env.REACT_APP_STRIPE_SCAN_PACKAGE_2;
    } else if (scanPackageBeingPurchased === 'scan_package_25') {
      stripeUrl = process.env.REACT_APP_STRIPE_SCAN_PACKAGE_3;
    } else if (scanPackageBeingPurchased === 'scan_package_100') {
      stripeUrl = process.env.REACT_APP_STRIPE_SCAN_PACKAGE_4;
    }

    if (!stripeUrl) {
      alert('There has been a problem. Please try again later!');
    } else {
      window.location.assign(stripeUrl);
    }
  };
  return (
    <div>
      <div>
        <Typography fontWeight={600} color={'primary'} fontSize={24}>
          Buy scan package
        </Typography>
        <Typography
          fontWeight={400}
          color='secondary'
          fontSize={18}
          style={{ marginTop: '8' }}
        >
          To buy extra scans you need an active subscription
        </Typography>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          flexWrap: 'wrap',
          width: '100%',
        }}
      >
        {user &&
          AVAILABLE_SCAN_PACKAGES.map((scanPackage) => (
            <ScanPackageCell
              scanPackage={scanPackage}
              key={scanPackage.product_id}
              onPressSubscribe={(scanPackage: ScanPackage) =>
                purchaseScanPackage(scanPackage)
              }
            />
          ))}
      </div>
      <ScanPackagePurchasedModal
        open={scanPackagePurchased}
        loading={loading}
        onClose={() => {
          getMeMutation();
          setScanPackagePurchased(false);
        }}
      />
      {user && (
        <>
          <ScanPackageConfirmationModal
            open={confirmScanPackage}
            onClose={() => cancelPurchase()}
            onConfirm={() => confirmPurchase()}
            email={user.email}
          />
          <SubscriptionRequiredModal
            open={subscriptionRequiredModal}
            onClose={() => setSubscriptionRequiredModal(false)}
          />
        </>
      )}
    </div>
  );
};

export default ScanPackages;
